import { Component, Input } from '@angular/core';

import { IdtComponent } from 'shared/models/idt-components/idt-component.models';


@Component({
  selector: 'render-layout[layout]',
  templateUrl: 'render-layout.component.html',
  styleUrls: ['./render-layout.component.scss']
})
export class RenderLayoutComponent {

  @Input() public layout!: IdtComponent;

}
